import axios from 'axios'
import store from './store'

const FairApi = {
    init(baseUrl) {
        axios.defaults.baseURL = baseUrl
    },

    login(param) {
        return this.getResourceWithParam('/signin', param)
    },

    signup(param) {
        return this.getResourceWithParam('/signup', param)
    },

    organization(param) {
        return this.getResourceWithParam('/organization', param)
    },

    organizationAll(param) {
        return this.getResourceWithParam('/organization/all', param)
    },

    organizationUpdate(param) {
        return this.getResourceWithParam('/organization/update', param)
    },

    organizations(param) {
        return this.getResourceWithParam('/organizations', param)
    },

    organizationToken(id) {
        return this.getResourceWithParam('/user/token/organization', id)
    },

    campaign(param) {
        return this.getResourceWithParam('/campaign', param)
    },

    campaignClosed(param) {
        return this.getResourceWithParam('/campaign/closed', param)
    },

    team(param) {
        return this.getResourceWithParam('/team', param)
    },

    teamById(id) {
        return this.getResourceWithParam('/team/info', id)
    },

    teamNearby(param) {
        return this.getResourceWithParam('/team/nearby', param)
    },

    users(param) {
        return this.getResourceWithParam('/users', param)
    },

    user(param) {
        return this.getResourceWithParam('/user', param)
    },

    userResetPsw(email) {
        let base64Email = null
        if (email) {
            base64Email = encodeURIComponent(btoa(email));
        }
        return this.getResourceWithParam('/user', base64Email) + '/password/reset'
    },

    userChangePsw(param) {
        return this.getResourceWithParam('/user/password/change', param)
    },

    stripeAuth(param) {
        return this.getResourceWithParam('/stripe/auth', param)
    },

    oneTimePaymentSession(campaign) {
      return this.getResourceWithParam('/payment', campaign) + '/onetime/session'
    },

    oneTimePaymentOffSession(campaign) {
        return this.getResourceWithParam('/payment', campaign) + '/onetime/offsession'
    },

    subscriptionPaymentSession(campaign, plan) {
        return this.getResourceWithParam('/payment', campaign) +
            this.getResourceWithParam('/subscription', plan) + '/session'
    },

    subscriptionPaymentOffSession(campaign, plan) {
        return this.getResourceWithParam('/payment', campaign) +
            this.getResourceWithParam('/subscription', plan) + '/offsession'
    },

    teamUpdate(team) {
        return this.getResourceWithParam('/team/update', team)
    },

    campaignUpdate(campaign) {
        return this.getResourceWithParam('/campaign/update', campaign)
    },

    organizationPhotoUrl(id) {
        return this.getResourceWithParam('/organization', id) + '/photo'
    },

    teamMember(team, member) {
        let teamRef = this.getResourceWithParam('/team', team)
        let memberRef = this.getResourceWithParam('/member', btoa(member))
        return teamRef + memberRef
    },

    subscription(param) {
        return this.getResourceWithParam('/subscription', param)
    },

    payment(param) {
        return this.getResourceWithParam('/payment', param)
    },

    photo(param) {
        return this.getResourceWithParam('/photo', param)
    },

    paymentMethod(param) {
        return this.getResourceWithParam('/payment/method', param)
    },

    defaultPaymentMethod(param) {
        return this.getResourceWithParam('/payment/method', param) + '/default'
    },

    getResourceWithParam(resource, param) {
        if (param) {
            resource += '/' + param
        }
        return resource
    },

    setHeader() {
        axios.defaults.headers.common["Authorization"] = store.state.token
        // Optional organization filter for showing only certain organization data in frontend
        let orgId = process.env.VUE_APP_ORGANIZATION_ID
        if (orgId) {
            axios.defaults.headers.common['X-FairOrganizationId'] = orgId
        }
    },

    handleFairAthentificationException(response, failCallback) {
        if (response.status === 401 && store.state.token) {
            store.commit('storeToken', null)
        } else {
            failCallback(response)
        }
    },

    get(resource, successCallback, failCallback) {
        return axios.get(resource)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    successCallback(response.data)
                } else {
                    failCallback(response)
                }
            })
            .catch(e => {
                this.handleFairAthentificationException(e.response, failCallback)
            })
    },

    getWithParams: function (resource, data, successCallback, failCallback) {
        axios.get(resource, {
            params: data
        })
            .then(response => {
                if (response.status === 200) {
                    successCallback(response.data)
                } else {
                    failCallback(response)
                }
            })
            .catch(e => {
                this.handleFairAthentificationException(e.response, failCallback)
            })
    },

    postWithFile: function (url, data, formData, successCallback, failCallback) {
        if (formData === null) {
            formData = new FormData()
        }
        formData.append('json', JSON.stringify(data))

        axios.post(url, formData, {
            'Content-Type': 'multipart/form-data',
        })
            .then(response => {
                if (response.status === 200) {
                    successCallback(response.data)
                } else {
                    failCallback(response.data)
                }
            })
            .catch(e => {
                this.handleFairAthentificationException(e.response, failCallback)
            })
    },

    post(resource, data, successCallback, failCallback) {
        return axios.post(resource, data)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    successCallback(response.data)
                } else {
                    failCallback(response)
                }
            })
            .catch(e => {
                this.handleFairAthentificationException(e.response, failCallback)
            })
    },

    put: function (resource, data, successCallback, failCallback) {
        return axios.put(resource, data)
            .then(response => {
                if (response.status === 200) {
                    successCallback(response.data)
                } else {
                    failCallback(response)
                }
            })
            .catch(e => {
                this.handleFairAthentificationException(e.response, failCallback)
            })
    },

    delete: function (resource, successCallback, failCallback) {
        return axios.delete(resource)
            .then(response => {
                if (response.status === 200) {
                    successCallback(response.data)
                } else {
                    failCallback(response)
                }
            })
            .catch(e => {
                this.handleFairAthentificationException(e.response, failCallback)
            })
    }
}

export default FairApi;